import courseData from "./course.json";
import type { Course } from "../types";
import { reframeLesson } from "./lesson-frames";

const course = courseData as unknown as Course;

export const activeCourse: Course = {
  ...course,
  lessons: course.lessons.map(reframeLesson),
};
